import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetTempDataApiKeyUsage, GetFullUsageOverviewAnalyses, GetJobTitleUsageOverviewAnalyses };

function GetTempDataApiKeyUsage(fromDate, toDate, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/analyses/apikeyusage/excel?fromDate=" + fromDate + "&toDate=" + toDate,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetFullUsageOverviewAnalyses(fromDate, toDate, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/analyses/fullusage/excel?fromDate=" + fromDate + "&toDate=" + toDate,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}


function GetJobTitleUsageOverviewAnalyses(fromDate, toDate, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/analyses/jobtitle/excel?fromDate=" + fromDate + "&toDate=" + toDate,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
